var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('NotificationsList',{attrs:{"loading":_vm.loading,"cifs":_vm.cifs,"cifsList":_vm.cifsList,"notificationsMax":_vm.notificationsMax,"notificationsUsed":_vm.notificationsUsed},on:{"setCancelLoad":_vm.setCancelLoad}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }